import React from 'react';

function TRow(props: any) {
  return <tr {...props} />;
}

export default TRow;
